import {
  Bot,
  Globe,
  LayoutDashboard,
  LineChart,
  Megaphone,
  MessageCircle,
  Radar,
  Search,
  Server,
  Sparkles,
  UserSearch,
  Workflow,
  type LucideIcon,
} from 'lucide-react';
import { ServiceSlug } from './services';

export const SERVICE_CAROUSEL_ICONS: Record<ServiceSlug, LucideIcon> = {
  'internal-software': Server,
  'process-automation': Workflow,
  'chatbots-virtual-agents': MessageCircle,
  'rags-knowledge-systems': Bot,
  'custom-dashboards': LayoutDashboard,
  'forecasting-classification': LineChart,
  'websites-virtual-businesses': Globe,
  'technical-seo-audit': Search,
  'meta-ads-audit': Megaphone,
  'global-digital-audit': Radar,
  'automated-prospecting': UserSearch,
  'custom-ai-tools': Sparkles,
};

export const SERVICE_CAROUSEL_ICON_LABELS: Record<ServiceSlug, { en: string; es: string }> = {
  'internal-software': { en: 'Internal ops', es: 'Ops internas' },
  'process-automation': { en: 'Automation', es: 'Automatización' },
  'chatbots-virtual-agents': { en: 'Chatbots', es: 'Chatbots' },
  'rags-knowledge-systems': { en: 'Knowledge AI', es: 'Conocimiento IA' },
  'custom-dashboards': { en: 'Dashboards', es: 'Dashboards' },
  'forecasting-classification': { en: 'Forecasting', es: 'Pronósticos' },
  'websites-virtual-businesses': { en: 'Web & brand', es: 'Web y marca' },
  'technical-seo-audit': { en: 'SEO audit', es: 'Auditoría SEO' },
  'meta-ads-audit': { en: 'Meta ads', es: 'Meta ads' },
  'global-digital-audit': { en: 'Digital audit', es: 'Auditoría digital' },
  'automated-prospecting': { en: 'Prospecting', es: 'Prospección' },
  'custom-ai-tools': { en: 'Custom AI', es: 'IA a medida' },
};
